module.exports = __webpack_public_path__ + "static/media/badge-diamond.aac9bd8d.png";